import { render, staticRenderFns } from "./GameCreation.vue?vue&type=template&id=f30a5fcc&scoped=true&"
import script from "./GameCreation.vue?vue&type=script&lang=js&"
export * from "./GameCreation.vue?vue&type=script&lang=js&"
import style0 from "./GameCreation.vue?vue&type=style&index=0&id=f30a5fcc&prod&lang=scss&scoped=true&"
import style1 from "./GameCreation.vue?vue&type=style&index=1&id=f30a5fcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30a5fcc",
  null
  
)

export default component.exports